export const URL_SUFFIX_LOCALCONTENT_COLLECTION = 'collection';
export const URL_LOCALCONTENT_ROUTE = 'localcontent';
export const URL_SUFFIX_LOCALCONTENT_ALL_TITLES = 'products';
export const URL_SUFFIX_LOCALCONTENT_PRODUCT_DETAILS = 'products';
export const URL_SUFFIX_LOCALCONTENT_PRODUCT_DETAILS_ID = ':id';
export const URL_SUFFIX_LOCALCONTENT_PERFORMERS = 'performers';
